
import { defineComponent, PropType } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import OkButton from '@/modules/OktellModule/components/OkButton/index.vue'

export default defineComponent({
    components: {
        Loader,
        OkButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        statuses: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
    },
    emits: ['reload'],
    setup(props, { emit }) {
        const emitReload = () => {
            emit('reload')
        }

        return {
            emitReload,
        }
    },
})
